import { useState, useEffect } from 'react';
import useDataBean from '../../../../../core/services/dataBean/useDataBean';
import { _CertificateYears } from '../../../../../core/services/dataBean/EntityCatalogVdos';


interface Props {
    idSelector: number | string;
    onChange: any;
    label?: string;
    disable?: boolean;
}

export const CertificateYears = ({ idSelector, onChange, label, disable = false }: Props) => {
    const CertificateYears = useDataBean(_CertificateYears);
    const [lista, setLista] = useState<number[]>([]);
    const [id, setID] = useState<string | number>(idSelector);

    useEffect(() => {
        getLista();
    }, []);

    useEffect(() => {
        if (idSelector !== id) {
            setID(idSelector);
        }
    }, [idSelector]);

    const setValue = (e: React.ChangeEvent<HTMLSelectElement>) => {
        const selectedValue = Number(e.target.value);
        setID(selectedValue);
        onChange(selectedValue);
    };

    const getLista = () => {
        CertificateYears.instance.getInfoForTaxCertificateYears(null).then(
            (resp: any) => {
                // if (resp?.DataBeanProperties?.ObjectValue) {
                //     setLista(resp.DataBeanProperties.ObjectValue);
                // }}
                setLista(resp)
            }
        );
    };

    return (
        <>
            <label>{label ?? "Vigencia:"}</label>
            <select className="form-select" disabled={disable} value={id} onChange={setValue}>
                <option value="">...</option>
                {lista.map((item, index) => (
                    <option key={index} value={item}>
                        {item}
                    </option>
                ))}
            </select>
        </>
    );
};